import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


export default class SectionRecentlyTimeline {
  constructor(dom) {
    window.addEventListener("resize", () => this.resize());
    this.dom = dom

    this.loading = false

    this.dates = this.dom.querySelectorAll('.month_days .date')
    this.date_active = null
    this.slider_items = this.dom.querySelectorAll('.www-slider .item')

    this.el_slider = this.dom.querySelector('.www-slider[data-type="_programme_list"]')
    this.el_dates = this.dom.querySelector('.www-slider[data-type="_month_days"]')
    this.el_msg = this.dom.querySelector('.msg-select-day')
    this.el_select = this.dom.querySelector('.select-month select')

    this.handleInit()

    this.el_select.addEventListener('change', (e) => {
      // console.log(e.target.value);
      this.getMonthList(e.target.value)
    })
  }

  init() {

  }

  handleInit() {
    let el_today = this.dom.querySelector('.month_days .date .date--wrap[is_today]')?.parentNode

    if (el_today) {
      this.sliderFilter(el_today)
    } else {
      this.showMsg()
      setTimeout(() => {
        ScrollTrigger.refresh()
      }, 1000)
    }

    this.dates.forEach((item, i) => {
      item.addEventListener('click', () => {
        if (this.loading) {
          return
        }
        if (item.querySelector('[has_items]:not([before_today1])')) {
          this.sliderFilter(item)
        }
      })
    })
  }

  sliderFilter(el_date) {
    const date = el_date.dataset.date
    let active_item = 0
    this.slider_items.forEach((slider_item, i) => {
      const dates = slider_item.dataset.dates

      // console.log(dates, date, dates.includes(date));

      if (dates.includes(date)) {
        slider_item.style.display = 'block'
        active_item++
      } else {
        slider_item.style.display = 'none'
      }
    });

    this.dom.querySelector('.month_days .date.active')?.classList.remove('active')

    if (active_item) {
      el_date.classList.add('active')
      this.el_slider.classList.remove('d-none')
      this.el_msg.classList.add('d-none')
      const event = new CustomEvent("handleProgrammeList", {
        detail: {
          type: 'filter',
          id: this.el_slider.dataset.id
        }
      });
      document.dispatchEvent(event);
    } else {
      this.showMsg()
    }


    setTimeout(() => {
      ScrollTrigger.refresh()
    }, 1000)
  }

  showMsg() {
    this.el_slider.classList.add('d-none')
    this.el_msg.classList.remove('d-none')
  }

  getMonthList(month) {
    if (this.loading) {
      return
    }

    this.loading = true

    fetch("?api=getMonthList", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        target_month: month,
      }),
    })
    .then((response) => response.json())
    .then((response) => {
      this.loading = false

      const el_slider_id = this.el_slider.dataset.id
      const el_dates_id = this.el_dates.dataset.id

      let new_slider = document.createElement("div");
      new_slider.innerHTML = response.sliders.trim();
      let new_dates = document.createElement("div");
      new_dates.innerHTML = response.dates.trim();

      this.el_slider.parentNode.replaceChild(new_slider.firstChild, this.el_slider);
      this.el_dates.parentNode.replaceChild(new_dates.firstChild, this.el_dates);
      // this.el_dates.parentNode.replaceChild(new_dates.firstChild, this.el_dates);

      this.dates = this.dom.querySelectorAll('.month_days .date')
      this.date_active = null
      this.slider_items = this.dom.querySelectorAll('.www-slider .item')

      this.el_slider = this.dom.querySelector('.www-slider[data-type="_programme_list"]')
      this.el_dates = this.dom.querySelector('.www-slider[data-type="_month_days"]')
      this.el_slider.dataset.id = el_slider_id
      this.el_dates.dataset.id = el_dates_id

      const event1 = new CustomEvent("handleSliderProgrammeList", {
        detail: {
          type: 'reset',
          id: el_slider_id,
          el: this.el_slider
        }
      });
      const event2 = new CustomEvent("handleSliderMonthDays", {
        detail: {
          type: 'reset',
          id: el_dates_id,
          el: this.el_dates
        }
      });
      document.dispatchEvent(event1);
      document.dispatchEvent(event2);

      this.handleInit()
    })
  }

  resize() {
  }

}
